export default {
      id: "Rectangle 9273-usage",
      viewBox: "0 0 60 60",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#Rectangle 9273",
      toString: function () {
        return this.url;
      }
    }